import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'stc-apps-presention-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './presention-icon.component.svg',
  styleUrls: ['./presention-icon.component.scss'],
})
export class PresentionIconComponent {}
